import React from "react";
import { motion } from "framer-motion";
import { getMotionProperties, easeSlow } from "../../../utils/motionUtils";
import { useMediaQueries } from "../../../utils/mediaQueries";
import ButtonPrimary from "../Buttons/ButtonPrimary";
import styles from "./ContentArticle.module.css";

const ContentArticle = () => {
  const { mq1024, mq430 } = useMediaQueries();

  return (
    <motion.article
      {...getMotionProperties("-100px, 0", "0, 0", easeSlow)}
      className={styles.containerContent}
    >
      <div className={styles.containerHeader}>
        <h1 className={styles.textHeaderLight}>Gamechanger</h1>
        {(!mq1024 || !mq430) && (
          <>
            {!mq1024 && (
              <>
                <h1 className={styles.textHeaderBold}>For Sports</h1>
                <h1 className={styles.textHeaderLight}>Governance</h1>
              </>
            )}
            {mq1024 && !mq430 && (
              <h1 className={styles.textHeaderBold}>For Sports Governance</h1>
            )}
          </>
        )}
        {mq430 && (
          <>
            <h1 className={styles.textHeaderBold}>For Sports</h1>
            <h1 className={styles.textHeaderLight}>Governance</h1>
          </>
        )}
      </div>

      <p className={styles.textParagraph}>
        No matter what laws and regulations you are in charge of, every sports
        organization faces similar issues: rules constantly change, they must be
        distributed, and the numerous sources and versions need to be managed.
        If we add to it the multiple tools and the necessity to communicate
        globally with a message that is both clear and always current, a
        significant challenge arises.
        <br />
        <br />
        Now imagine a solution to this problem, a true gamechanger!
      </p>
      <ButtonPrimary
        showButtonText={true}
        showIconLeft={false}
        showIconRight={true}
        altIconLeftText=""
        altIconRightText="Icon Arrow Right"
        buttonDisplayMode=""
        buttonPrimaryLink="https://outlook.office.com/book/ROSARulesofSportsApp@mamf.pl/?ismsaljsauthenabled"
        buttonPrimaryText="Get your own app"
        buttonWidth=""
        iconLeftURL=""
        iconRightURL="/icons/arrow.right.svg"
        radiusX="16"
        radiusY="4"
        radiusXHover="32"
        radiusYHover="8"
      />
    </motion.article>
  );
};

export default ContentArticle;
